// extracted by css-extract-rspack-plugin
export default {"middlePaneGrid":"IssueIndexPage-module__middlePaneGrid__zJ6nJ66","feedbackLinkContainer":"IssueIndexPage-module__feedbackLinkContainer__tCjNEC3"};